window.track = function(category, action, label) {
  if(typeof(window.ga) == "undefined") return;
  var sampleRate = 1;
  if(category == "Editor" || category == "Images") {
    sampleRate = 1000;
  }
  if(sampleRate > 1 && Math.random() > 1/sampleRate) {
    return;
  }
  window.ga('send', {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label
  })
}
